import React from "react";
import { Loader } from "lucide-react";

/**
 * Simple className merge (no @/lib/utils dependency).
 */
function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

/**
 * Spinner using Loader icon from lucide-react.
 * Used for navbar sections: Detailed Inventory, Master Address, Reports, Client Administration.
 * (The file-upload overlay on Client Administration is separate and unchanged.)
 */
function Spinner({ className = "", ...props }) {
  return (
    <Loader
      role="status"
      aria-label="Loading"
      className={cn("w-4 h-4 animate-spin", className)}
      {...props}
    />
  );
}

export function SpinnerCustom({ className = "" }) {
  return (
    <div className={cn("flex items-center gap-4", className)}>
      <Spinner />
    </div>
  );
}

export default Spinner;
